<template>
    <simplebar class="chat-message-list" id="chat-list" ref="current">
        <div class="media-body">
            <ul class="list-unstyled chat-list chat-user-list">
                <li v-for="(convo, index) in convos" :key="`convo-`+index"
                    class="d-flex align-items-left p-3 border-bottom cursor-pointer"
                    @click="selectConvo(convo)">
                    <div class="text-right w-100 border-bottom-1">
                        <div class="convo-body d-flex w-100">
                            <font-awesome-icon :icon="['fas', 'comment']"
                                               class="mr-1"
                            ></font-awesome-icon>
                            <h5 class="text-truncate font-size-15 mb-1">
                                Conversation - {{ convo }}
                            </h5>
                        </div>
                        <p class="chat-time mb-0 font-size-10">
                            <i class="ri-time-line align-middle"></i>
                            <span class="align-middle">{{showCurTime}}</span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </simplebar>
</template>

<script>
import simplebar from 'simplebar-vue';
import moment from 'moment';

export default {
    components: {simplebar},
    props: {
        convos: {
            type: Array,
            required: true
        },
        activeConvo: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    computed: {
        showCurTime(){
            return moment().format('LT')
        },
    },
    methods: {
        selectConvo(convo){
            this.$emit('selectConvo', convo)
        }
    }
}

</script>

<style scoped lang="scss">

</style>
